import { Routes } from '@angular/router';
import { EnterpriseSubscriptionGuard } from '../../security/enterprise-subscription.guard';
import { PermissionGuard } from '../../security/permission.guard';
import { app_permissions } from '../../security/app-permissions';
import { MyHrApprovalsComponent } from './approvals/my-hr-approvals.component';
import { MyHrDocumentsComponent } from './documents/my-hr-documents.component';
import { MyHrExpensesComponent } from './expenses/my-hr-expenses.component';
import { MyHrHomeComponent } from './home/my-hr-home.component';
import { MyHrLearningComponent } from './learning/my-hr-learning.component';
import { MyHrLeaveComponent } from './leave/my-hr-leave.component';
import { MyHrPayslipsComponent } from './payslips/my-hr-payslips.component';
import { MyHrProfileComponent } from './profile/my-hr-profile.component';
import { MyHrShellComponent } from './shell/my-hr-shell.component';
import { MyHrTeamComponent } from './team/my-hr-team.component';
import { MyHrTimesheetsComponent } from './timesheets/my-hr-timesheets.component';

const myHrRouteData = {
  enterpriseModules: ['HR'],
  enterpriseFeatureLabel: 'My HR'
};

const myHrAccessPermissions = [
  app_permissions.hr.self.view,
  app_permissions.hr.manager.view
];

export const myHrRoutes: Routes = [
  ...[
    ['my-profile', 'profile'],
    ['my-documents', 'documents'],
    ['my-leave', 'leave'],
    ['my-timesheets', 'timesheets'],
    ['my-payslips', 'payslips'],
    ['my-learning', 'learning']
  ].map(([path, target]) => ({
    path,
    redirectTo: `my-hr/${target}`,
    pathMatch: 'full' as const
  })),
  {
    path: 'my-hr',
    component: MyHrShellComponent,
    canActivate: [EnterpriseSubscriptionGuard, PermissionGuard],
    canActivateChild: [PermissionGuard],
    data: {
      ...myHrRouteData,
      permission: myHrAccessPermissions
    },
    children: [
      {
        path: '',
        component: MyHrHomeComponent,
        data: {
          ...myHrRouteData,
          permission: myHrAccessPermissions
        }
      },
      {
        path: 'profile',
        component: MyHrProfileComponent,
        data: {
          ...myHrRouteData,
          permission: app_permissions.hr.self.view
        }
      },
      {
        path: 'documents',
        component: MyHrDocumentsComponent,
        data: {
          ...myHrRouteData,
          permission: app_permissions.hr.self.view
        }
      },
      {
        path: 'leave',
        component: MyHrLeaveComponent,
        data: {
          ...myHrRouteData,
          permission: app_permissions.hr.self.view
        }
      },
      {
        path: 'timesheets',
        component: MyHrTimesheetsComponent,
        data: {
          ...myHrRouteData,
          permission: app_permissions.hr.self.view
        }
      },
      {
        path: 'payslips',
        component: MyHrPayslipsComponent,
        data: {
          ...myHrRouteData,
          permission: app_permissions.hr.self.view
        }
      },
      {
        path: 'learning',
        component: MyHrLearningComponent,
        data: {
          ...myHrRouteData,
          permission: app_permissions.hr.self.view
        }
      },
      {
        path: 'expenses',
        component: MyHrExpensesComponent,
        data: {
          ...myHrRouteData,
          permission: [app_permissions.expense.records.view, app_permissions.expense.records.create]
        }
      },
      {
        path: 'approvals',
        component: MyHrApprovalsComponent,
        data: {
          ...myHrRouteData,
          permission: myHrAccessPermissions
        }
      },
      {
        path: 'team',
        component: MyHrTeamComponent,
        data: {
          ...myHrRouteData,
          permission: app_permissions.hr.manager.view
        }
      }
    ]
  }
];
